exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr-codescan{position:fixed;top:0;right:0;width:100%;height:100%;background:#fff;padding:30px;z-index:999;padding-bottom:60px}.close-qr-reader{margin-bottom:30px;display:inline-block;cursor:pointer}.qr-code-frame{height:calc(100% - 60px);position:relative;overflow:hidden}", ""]);

// exports
